import { Cache, Dic, Dates } from "$utils";
import log from "./log";

var ALARM_CACHE_LIST = [];

const webscoket = {
  initWebSocket: function ($vue) {
    const access_token = Cache.get("CACHE_USER_INFO").access_token;
    const socketIps = Cache.get("SCOKET_OPTIONS");
    if (!socketIps || !socketIps.length) return;
    this.closeSocket();
    window.iocSockets = [];
    socketIps.forEach((item) => {
      const wsUri = `${item}/bas/websocket?ticket=${access_token}`;
      let websocket = new WebSocket(wsUri);
      window.iocSockets.push(websocket);
      websocket.onopen = function (evt) {
        log.info("Webscoket连接成功，服务器地址：", wsUri);
        window["ScoketInterval"] = setInterval(function () {
          websocket.send("{key: 'heart'}");
        }, 30000);
      };
      websocket.onclose = function (evt) {
        log.debug("Webscoket连接关闭，服务器地址：", wsUri);
        websocket.close();
      };
      websocket.onmessage = function (evt) {
        let data = undefined;
        try {
          data = JSON.parse(evt.data);
          // console.log('接受到Websocket消息，消息体：', data)
          if (data.key === "ack") {
            return;
          } else {
            todo(data, $vue);
          }
        } catch (e) {
          log.error("Webscoket消息发送失败，错误信息为：", e);
        }
      };
      websocket.onerror = function (evt) {
        websocket = new WebSocket(wsUri);
      };
    });
  },
  closeSocket() {
    if (window.iocSockets && window.iocSockets.length) {
      window.iocSockets.forEach((item) => {
        item.close();
      });
    }
  }
};

// 目前支持  视频巡更 实时告警 消防告警   --弹窗
function todo(message, $vue) {
  // console.log("websocket---", message);
  // log.info('接受到Websocket消息，消息体：', message)
  if (message.key === "videoPatrol.prompt.message") {
    $vue.appScoketDialogIsShow = true;
    Cache.put("videoPatrol-autoStart", message.body);
  }
  // 视频巡更
  if (message.key === "videoPatrol.autoStart.message") {
    if (
      $vue.$route.path === "/videoPatrol/task" ||
      window.location.hash === "#/videoPatrol/task"
    ) {
      //   $vue.$router.push({ path: '/videoPatrol/task' })
      Cache.put("videoPatrol-autoStart", message.body);
      if ($vue.appScoketDialogIsShow) {
        $vue.$refs.socketWindow.setWebsocketData();
      } else {
        $vue.appScoketDialogIsShow = true;
      }
    }
  }
  // 实时告警
  if (
    message.key === "ALARM" ||
    message.key == "FIREPATROLITEM_EXCEPTION_MESSAGE"
  ) {
    log.debug("告警推送的消息为：", message.body);
    message.body.key = message.key;
    let alarmData = {
      ...message.body,
      key: message.key,
      subSystemLabel:
        Dic.findByValue("SENU004", parseInt(message.body.subSystem)) ||
        "其他告警"
    };
    $vue.$store.commit("ADD_ALARM_TO_LIST", alarmData);
    $vue.$store.state.ioc.alarmNewList = alarmData;
    $vue.alarmDialog = alarmData;
  }
  // 消防火警
  if (message.key === "FIREFIGHTINGALARM") {
    let alarmData = {
      ...message.body,
      key: message.key,
      subSystemLabel:
        Dic.findByValue("SENU004", parseInt(message.body.subSystem)) ||
        "其他告警"
    };

    if ($vue.$router.currentRoute.path === "/fireAlarm") {
      // 只有在消防当前页面才显示告警弹窗
      $vue.alarmDialog = alarmData;
      $vue.$store.state.ioc.fireAlarmNewList = alarmData;
    }
    $vue.$store.commit("ADD_ALARM_TO_LIST", alarmData);
  }
  // else if (message.key === "MATCHRECORD") {
  //   // 识别记录
  //   $vue.$store.state.ioc.strangerList = message.body;
  //   if ($vue.$router.currentRoute.path === "/access/identifyCenter") {
  //     $vue.alarmDialog = message.body;
  //   }
  // }
  else if (message.key === "vehicleTrafficInfo") {
    // 出入口过车记录
    $vue.$store.commit("CAR_PASS_RECORD", message.body);
  } else if (message.alarmCount && message.alarmCount.length) {
    // 告警数量
    let alarmCount = 0;
    message.alarmCount.forEach((item) => {
      alarmCount += parseInt(item.value);
    });
    $vue.$store.commit("SET_ALARM_COUNT", alarmCount);
  } else if (message.key == "BROADCAST_MONITOR_MESSAGE") {
    //出入口值守
    $vue.$store.commit("SET_BROADCAST_MESSAGE", message.body);
    setTimeout(() => {
      this.$store.commit("REMOVE_BROADCAST_MESSAGE", message.body);
    }, 1000 * 30);
  }
  //  else if (message.key == "FIREPATROLITEM_EXCEPTION_MESSAGE") {
  //   // // 巡查项异常
  //   // $vue.alarmDialog = message.body;
  //   // $vue.alarmDialog.key = message.body;
  // }
}
export default webscoket;
